import * as React from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import EditIcon from '@mui/icons-material/Edit';
import '../../assets/css/Profile.css';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


const Profile = () => {
    const reduxState = useSelector((state) => state.Auth.user);
    // console.log(reduxState , "from redux state profile page");

    const navigate = useNavigate();

    return (
        <div>
            <section className='profile'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>My Profile</p>
                        </div>
                        <div className='col-lg-4'>
                            <ProfileTab />
                        </div>
                        <div className='col-lg-8 pl-5 mb-5 res-pxx'>
                            <div className='row'>
                                <div className='col-lg-12 profileOrderList'>
                                    <p className='f-pop-bold f-30'>Account</p>
                                </div>
                                <div className='col-lg-6 profileOrderListset'>
                                    <p className='f-pop-bold f-30'>Account</p>
                                </div>
                                <div className='col-lg-6 profileOrderListset'>
                                    <p onClick={() => { navigate("/editprofile") }} className='edit_profile f-15 f-pop-reg edit_profile '>Edit <EditIcon className='ml-2 hght-icon-pro' /></p>
                                </div>
                                <div className='col-lg-4 '>
                                    <p className='f-mon-reg clr-white-light f-16 mb-1'>First Name</p>
                                    <p className='f-mon-reg f-18 mb-4'>{reduxState.first_name}</p>
                                    <p className='f-mon-reg clr-white-light f-16 mb-1'>Phone</p>
                                    <p className='f-mon-reg f-18 mb-4'>{reduxState.phone_no}</p>
                                    <p className='f-mon-reg clr-white-light f-16 mb-1'>Password</p>
                                    <p className='f-mon-reg f-40 mb-4 lh-0'>.......</p>
                                </div>
                                <div className='col-lg-6 '>
                                    <p className='f-mon-reg clr-white-light f-16 mb-1'>Last Name</p>
                                    <p className='f-mon-reg f-18 mb-4'>{reduxState.last_name}</p>
                                    <p className='f-mon-reg clr-white-light f-16 mb-1'>Email</p>
                                    <p className='f-mon-reg f-18 mb-4'>{reduxState.email}</p>
                                </div>
                                <div className='col-lg-2 '>
                                    <p onClick={() => { navigate("/editprofile") }} className='edit_profile f-15 f-pop-reg edit_profile profileOrderList'>Edit <EditIcon className='ml-2 hght-icon-pro' /></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Profile